import type { FC } from 'react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { LinkedJackpotslProps } from '../../types/jackpot.types';
import Image from '../../../../shared/components/Image';

import { useSettings } from '../../../../store/app/appStore';
import { testIds } from '../../../../core/testIds';

import styles from './LinkedJackpots.module.css';
import TransWithFallback from '../../../../shared/components/Translations/TransWrapper';

const LinkedJackpots: FC<LinkedJackpotslProps> = ({ linkedJackpots, order, sectionName }) => {
  const { restrictions } = useSettings();
  const hasNoJackpotRestriction = restrictions.includes('noJackpot');

  useTranslation();

  // Sort linked jackpots based on the provided order array
  const orderedJackpots = order
    ? linkedJackpots
        .filter((jackpot) => order.includes(jackpot))
        .sort((a, b) => order.indexOf(a) - order.indexOf(b))
    : linkedJackpots;

  return orderedJackpots?.length > 1 ? (
    <div className={styles.linkedJackpots}>
      <div className={styles.textWrapper}>
        <span>
          <TransWithFallback
            i18nKey={`sections.linked_${hasNoJackpotRestriction ? 'bonuses' : 'jackpots'}`}
            customFallbackTranslation={hasNoJackpotRestriction ? 'LINKED BONUSES' : 'LINKED JACKPOTS'}
          />
        </span>
      </div>
      <div className={styles.imagesContainer} data-testid={testIds.jackpots.linkedLogos(sectionName ?? '')}>
        {orderedJackpots?.map((jackpot) => (
          <Image
            key={jackpot}
            alt={jackpot}
            manualAffix=".png"
            src={`/badges/new/${jackpot.replace(' ', '_').toLowerCase()}`}
          />
        ))}
      </div>
      <div className={styles.textWrapper}>
        <span>
          <TransWithFallback
            i18nKey={'sections.all_in_one'}
            customFallbackTranslation="ALL IN ONE"
            components={{
              br: <br />,
            }}
          />
        </span>
      </div>
    </div>
  ) : null;
};

export default memo(LinkedJackpots);
